import { List, Map } from 'immutable';

import { getInventoryOperationValue } from '../../../product/getOperationValue';

import { ATTRIBUTE } from '../../../../constants/attributes';
import { ETSY } from '../../../../constants/channels';

export function processingProfile({ preview }) {
  return {
    payload: Map({
      type: preview.getIn([ATTRIBUTE.SHIPPING, 'operation']),
      value: List([
        getInventoryOperationValue({
          channel: ETSY,
          value: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.PROCESSING_PROFILE]),
        }),
      ]),
    }),
  };
}
